// React
import { useState, useEffect } from 'react'

// Components
import AlgoliaSearch from './AlgoliaSearch'

export default function ShopifyOrderSelect({
    onSelect,
    placeholder = 'Rechercher par OB, nom, email...',
    label = 'Commande Shopify',
    excludedIds = [],
    filters = null,
}) {
    return (
        <>
            <AlgoliaSearch
                algolia_index="engine_orders"
                placeholder={placeholder}
                onSelect={onSelect}
                label={label}
                excludedIds={excludedIds}
                filters={filters}
            />
        </>
    )
}
